import "../pages.scss"
import { ArticulosDepositoState } from '../../context/articulosDeposito/ArticulosDepositoState';
import Datatable from "./articulosDepositosTable/Datatable"

const ArticulosDepositoPage = () => {
  return (
    <>
      <ArticulosDepositoState>
        <Datatable />
      </ArticulosDepositoState>

    </>
  )
}

export default ArticulosDepositoPage